import Image from 'next/image'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from "react-bootstrap/Container"
import courseStyles from '../styles/CourseDetail.module.css'
import CourseContentAccordion from '../components/Course/CourseContentAccordion'
import CourseStartCard from '../components/Course/CourseStartCard'
import Meta from '../components/Meta'
import { server } from '../config'
import CourseArticleList from '../components/Course/CourseArticleList'
import { supabase } from "../utils/supabaseClient"


export default function CourseDetails(props) {
    // console.log(props.relArticles)
    return(
        <>
            <Meta 
                title='Building a Django Web App | From HTML to Python to Deployment' 
                description="This course provides in-depth instructions on how to create your own web app, start to finish." 
            />
            <Container fluid className={`card-img-top ${courseStyles.bg_2}`}>
                <Container className="py-5">
                <h1>Building a Django Web App</h1>
                <h5 className="lead">From HTML to Python to Deployment</h5>
                <br />
                <p><u>Requirements:</u> A computer. No coding experience necessary!</p>
                </Container>
            </Container>

            <Container>
                <Row>
                    {/* Column 1 */}
                    <Col lg={8} md={12} className="order-lg-1 order-2">
                        {/* Course Details */}
                        <div className="mb-5">
                            <div className={courseStyles.course_details}>
                                <h4 className="fw-bold ps-3">Course Details</h4>
                                <ul className="lead">
                                    <li>HTML, CSS, Bootstrap, Python, Django, Deployment</li>
                                    <li>25 in-depth lessons</li>
                                    <li>60+ instructional GIFs</li>
                                    <li>20+ in-browser code editors</li>
                                    <li>15+ coding challenges</li>
                                    <li>55+ quiz questions</li>
                                    <li>A Django tutorial project for beginners</li>
                                </ul>
                            </div>
                        </div>
                        {/* Content description */}
                        <div className="mb-5 text-dark">
                            <h4 className={courseStyles.subtitle}>Content Description</h4> 
                            <p>This course provides in-depth instructions on how to create your own web app, start to finish.
                            We will cover everything from the basic structures of HTML documents and stylesheets to Django
                            functionality, design, and deployment.
                            By the end, you will have a fully customizable web app with the possibility to monetize through Amazon&apos;s Associates Program.
                            <br /><br />
                            Satisfy your entrepreneurial endeavors by coding something with a purpose.
                            </p>
                        </div>
                        {/* Content Breakdown */}
                        <CourseContentAccordion />

                        {/* Format of Course */}
                        <div className="mb-5">
                            <h4 className={courseStyles.subtitle}>Format of the Course</h4>
                            <p>This course is provided online. Some lessons require downloading additional content/software.
                            To properly complete the course, users must have access to a computer with an operating system, such as macOS or Microsoft Windows.  Additional instructions are available for lightweight operating systems, such as Chrome OS.</p>
                        </div>

                        {/* Related Articles */}
                        <div className="pb-5">
                            {/* <h4 className={courseStyles.subtitle}>Related Articles</h4> */}
                            <br />
                            {/* <CourseArticleList articles={props.relArticles} /> */}
                        </div>

                    </Col>
                    {/* Column 2 */}
                    <Col lg={4} md={12} className="pb-5 order-lg-2 order-1">
                    <div className={courseStyles.card_con}>
                        <CourseStartCard />
                    </div>
                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}